import { useState } from 'react';
import { Mail, Loader2, Check } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function NewsletterSubscribe({ compact = false }) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('loading');
    try {
      const res = await fetch(`${API}/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), name: name.trim() || null }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setStatus('success');
        setMessage(data.message || "Thanks for subscribing!");
        setEmail('');
        setName('');
      } else {
        setStatus('error');
        setMessage(data.detail || 'Could not subscribe — please try again.');
      }
    } catch {
      setStatus('error');
      setMessage('Network error — please try again.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-2" data-testid="newsletter-subscribe-form">
      <h4 className="font-outfit font-semibold text-white mb-2 flex items-center gap-2">
        <Mail size={14} className="text-[#A78BFA]" /> Newsletter
      </h4>
      <p className="text-[#9CA3AF] text-xs font-outfit mb-3">Weekly stories, founding-vendor spotlights & community wins.</p>
      {!compact && (
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name (optional)"
          disabled={status === 'loading'}
          className="w-full px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-white text-sm placeholder-[#64748B] focus:outline-none focus:border-[#A78BFA]/50"
          data-testid="newsletter-name"
        />
      )}
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        required
        disabled={status === 'loading' || status === 'success'}
        className="w-full px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-white text-sm placeholder-[#64748B] focus:outline-none focus:border-[#A78BFA]/50"
        data-testid="newsletter-email"
      />
      <button
        type="submit"
        disabled={status === 'loading' || status === 'success'}
        className="w-full px-3 py-2 rounded-lg bg-yellow-400 hover:bg-yellow-300 text-black text-sm font-bold disabled:opacity-60 transition-all flex items-center justify-center gap-2"
        data-testid="newsletter-submit"
      >
        {status === 'loading' && <Loader2 size={14} className="animate-spin" />}
        {status === 'success' && <Check size={14} />}
        {status === 'success' ? 'Subscribed' : status === 'loading' ? 'Subscribing…' : 'Subscribe'}
      </button>
      {message && (
        <p className={`text-xs ${status === 'success' ? 'text-[#86EFAC]' : 'text-red-400'}`} data-testid="newsletter-message">{message}</p>
      )}
    </form>
  );
}
